<template>
    <div ref="animation" style="height: 100%; width:100%"></div>
</template>

<script>
    import Lottie from 'lottie-web'
    import {Howl} from 'howler';

    export default {
        name: "Animation",
        props: {
            value: {
                type: Boolean,
                default: false,
            },
            url: {
                type: String,
                required: true,
            },
            sound: {
                type: String,
                required: false,
            },
            loop: {
                type: Boolean,
                default: false,
            },
            autoplay: {
                type: Boolean,
                default: true
            },
            freezeFrame: {
                type: Number,
                required: false,
            },
            loopDelay: {
                type: Number,
                default: 0
            }
        },
        watch: {
            'value'(val) {
                val ? this.animation.play() : this.animation.stop();
            },
            ready: {
                handler() {

                    if (this.ready.animation && this.ready.sound)
                        this.$emit('ready');

                },
                deep: true,
            }
        },
        data() {
            return {
                animation: null,
                ready: {
                    animation: false,
                    sound: false,
                },
                loopDelayTimeout: null
            }
        },
        methods: {
            initAnimation() {
                this.animation = Lottie.loadAnimation({
                    container: this.$refs.animation,
                    renderer: 'svg',
                    path: this.url,
                    autoplay: this.autoplay,
                    loop: this.loop,
                });

                if (!this.autoplay && !this.value) {
                    this.animation.addEventListener('data_ready', this.animationReady);
                }


                if (!this.autoplay && this.value) {
                    if (this._sound != null)
                        this._sound.play();

                    this.animation.play();
                }

                if (!this.loop) {
                    this.animation.onComplete = () => {
                        this.$emit('complete');
                        if (this.freezeFrame != null) {
                            this.animation.goToAndStop(this.freezeFrame, true);
                        }
                    };
                }

                if (this.loopDelay > 0) {
                    this.animation.onComplete = () => {
                        clearTimeout(this.loopDelayTimeout);
                        this.loopDelayTimeout = setTimeout(() => {
                            if (this._sound != null)
                                this._sound.play();
                            this.animation.goToAndPlay(0);
                        }, this.loopDelay);
                    };
                }
            },
            animationReady() {
                this.$set(this.ready, 'animation', true);
            },
            soundReady() {
                this.$set(this.ready, 'sound', true);
            }
        },
        beforeDestroy() {
            if (this._sound != null) this._sound.unload();
            this.animation.removeEventListener('data_ready', this.animationReady);
            this.animation.destroy();
            clearTimeout(this.loopDelayTimeout);
        },
        mounted() {

            if (this.sound != null) {
                this._sound = new Howl({
                    src: [this.sound],
                    autoplay: this.autoplay,
                    loop: false,
                });

                this._sound.once('onload', this.soundReady());
            } else {
                this._sound = null;
                this.soundReady(); //sound is 'ready' if there is no sound
            }

            this.initAnimation();
        }
    }
</script>

<style scoped>

</style>
